import { cn } from '@form-factory/chatbot-ui';
import type { EfGetMemberClassReservationsResponse } from '@form-factory/schema/contracts';
import { DateFormat, formatUtils } from '@form-factory/shared';
import { Trans } from '@lingui/react/macro';
import { Clock11Icon } from 'lucide-react';

import { useRouter } from '@/hooks/useRouter';

interface ReservationCardProps {
  reservationData: EfGetMemberClassReservationsResponse['results'][number];
}

export function ReservationCard({ reservationData }: ReservationCardProps) {
  const { pushRoute } = useRouter();

  const { className, roomName, startDate, endDate, positionOnWaitList } =
    reservationData;
  const startTime = formatUtils.date(startDate, DateFormat.Time);
  const endTime = formatUtils.date(endDate, DateFormat.Time);
  const hasStarted = startDate && new Date(startDate) < new Date();

  return (
    <button
      type='button'
      onClick={() => pushRoute('groupClassDetail', reservationData)}
      className={cn(
        'mb-2 flex w-full flex-row items-start justify-between gap-2 rounded-md bg-chat-background-secondary px-3 py-2',
        hasStarted && 'opacity-50',
      )}
    >
      <div className='w-full text-left'>
        {positionOnWaitList && (
          <div className='mb-2 inline-flex flex-nowrap items-center gap-1 rounded-md bg-amber-500/15 px-2 py-1 text-xs text-amber-600'>
            <Clock11Icon className='size-4' />
            <Trans>Waitlist position {positionOnWaitList}</Trans>
          </div>
        )}
        <div className='text-xs font-medium'>
          {formatUtils.date(startDate, DateFormat.Date)}
          {' | '}
          {startTime} - {endTime}
        </div>
        <div className='mt-1 whitespace-break-spaces break-words text-sm font-bold'>
          {className}
        </div>
        {roomName && <div className='mt-1 text-xs opacity-70'>{roomName}</div>}
      </div>
    </button>
  );
}
